export const ClientAcademiesTabData = [
  {
    id: 1,
    title: "ABC University",
    img_url: "images/Academies/clientspecific/ABCUniversity-New-Brand.png",
    portal_url: "https://atci.abcuniversity.accenture.com/",
    portal_content:
      "Upskill ABC Account employees at ATCI on key technologies.",
    portal_content_points: [
      `<ul>
        <li>Role-based learning: API Automation Testing, Manual Testing, SRE, TOSCA</li>
        <li>Skill-based learning:  Power BI, Python and SAP MM</li>
        <li>Process-based learning: General Process, SAP MM Process</li>
      </ul>`,
    ],
  },
  {
    id: 2,
    title: "ADNOC Academy",
    img_url: "images/Academies/clientspecific/ADNOCAcademy-New-Brand.png",
    portal_url: "https://atc.lkm.accenture.com/ADNOCTalentAcademy/home",
    portal_content:
      "Build a workforce equipped with diverse, future-ready skills for ADNOC Account employees at ATCI.",
    portal_content_points: [
      // `<ul>
      //   <li>Roles Base Learning: SAP Ariba Consultant, SAP Enterprise Asset Management (EAM) Consultant, SAP Finance (FIN) Consultant, SAP HCM Consultant</li>
      //   <li>Skill Base Learning: ADNOC-Specific Training, Analytical Skills, Automation and Innovation Skills, System Engineer, Functional Skills</li>
      // </ul>`,
    ],
  },
  {
    id: 3,
    title: "Atrias talent Academy",
    img_url: "images/Academies/clientspecific/Atrias-New-Brand.png",
    portal_url: "https://atci.lkm.accenture.com/AtriasTalentAcademy/",
    portal_content:
      "Enhance onboarding and cross-skill new and existing Atrias CMS employees at ATCI.",
    portal_content_points: [
      `<ul>
        <li>Learning offerings: Role-based and skill-based Learning</li>
        <li>Technology: .NET, AX Role, BA Role, BA – ST, BI Role, SL Role, DBA, Hubops</li>
      </ul>`,
    ],
  },
  {
    id: 4,
    title: "Barclays talent academy",
    img_url: "images/Academies/clientspecific/Barclays.png",
    portal_url: "https://atci.lkm.accenture.com/BarclaysAcademy/",
    portal_content:
      "Upskill Barclays Account employees at ATCI and build skills for new-age roles. ",
    portal_content_points: [
      `<ul>
        <li>Learning offerings: Mandatory Learning and Furlough Training</li>
      </ul>`,
    ],
  },
  {
    id: 5,
    title: "BNZ Talent Academy",
    img_url: "images/Academies/clientspecific/BNZ-Talent-Academy.png",
    portal_url: "https://atci.lkm.accenture.com/BNZTalentAcademy/",
    portal_content:
      "Upskill Sodexo Account employees at ATCI on advanced technologies.",
    portal_content_points: [
      `<ul>
        <li>Role-based learning: API Automation, Automation Tester in Development, BA and Scrum Master, SDET Skill-based learning: Cloud Automation Devops, Java Full Stack Developer, Multi-Platform UI Developer</li>
      </ul>`,
    ],
  },
  {
    id: 6,
    title: "Fedex Talent Academy",
    img_url: "images/Academies/clientspecific/FedEx-New-Brand.png",
    portal_url: "https://atc.lkm.accenture.com/FedExTalentAcademy/",
    portal_content:
      "Enhance the skills of FedEx Account employees at ATCI with cutting-edge technologies.",
    portal_content_points: [
      `<ul>
        <li>Learning offerings: Mandatory Learning, Technology Learning, Delivery Learning, Industry Learning, Compliance & Security Learning.</li>
        <li>Technology: Java Spring boot/Microservice, Selenium, Cucumber, Oracle Bas, Angular, .NET, Splunk, Oracle</li>
      </ul>`,
    ],
  },
  {
    id: 7,
    title: "Mocad Academy",
    img_url: "images/Academies/clientspecific/MOCADAcademy-New-Brand.png",
    portal_url: "https://atc.lkm.accenture.com/MortgageCadenceLearning/home",
    portal_content:
      "MoCad capability embodies a strong dedication to academic excellence, creating an enriching learning space that supports intellectual curiosity and career development in the mortgage industry.",
    portal_content_points: [],
  },
  {
    id: 8,
    title: "Nordea Talent Academy",
    img_url: "images/Academies/clientspecific/Nordea-New-Brand.png",
    portal_url: "https://atci.lkm.accenture.com/NordeaAcademy/",
    portal_content:
      "Enable Nordea Account employees at ATCI to upskill on frameworks across key tech areas.",
    portal_content_points: [
      `<ul>
        <li>Role-based learning: API Automation Testing, Manual Testing, Site Reliability Engineering</li>
        <li>Skill-based learning: Agile, AI, DevOps, Java, Power BI, Python</li>
        <li>Process-based learning: General Process</li>
      </ul>`,
    ],
  },
  {
    id: 9,
    title: "Rabobank Readi",
    img_url: "images/Academies/clientspecific/Rabo-New-Brand.png",
    portal_url: "https://atci.lkm.accenture.com/READI/",
    portal_content:
      "Upskill Rabobank Account employees at ATCI on emerging technologies.",
    portal_content_points: [
      `<ul>
        <li>Domains: Engineering and Enterprise, Retail NL Tech, Wholesale and Rural</li>
      </ul>`,
    ],
  },
  {
    id: 10,
    title: "Relex Academy",
    img_url: "images/Academies/clientspecific/Relex.png",
    portal_url: "https://atci.lkm.accenture.com/RelexAcademy/home",
    portal_content:
      "Build role-based industry skills for Relex Account employees at ATCI",
    portal_content_points: [
      `<ul>
        <li>Product Offerings: Demand Planning, Supply Chain, Merchandising, Operations</li>
        <li>Roles: Business Consultants, Solution Consultants, Solution Configurators</li>
      </ul>`,
    ],
  },
  {
    id: 11,
    title: "SAGE Talent Academy",
    img_url: "images/Academies/clientspecific/SageAcademy-New-Brand.png",
    portal_url: "https://atci.lkm.accenture.com/SageTalentAcademy/",
    portal_content:
      "Upskill Sage Account employees at ATCI and build skills for new-age roles.",
    portal_content_points: [
      `<ul>
        <li>Learning offerings: Domain base, process base product base, skill base Technology: AWS Basics, Azure DevOps, Azure Pass, Data Engineer, Frontend Developer, IOS Developer, Automation Testing, Manual Testing.</li>
      </ul>`,
    ],
  },
  {
    id: 12,
    title: "Shell University",
    img_url: "images/Academies/clientspecific/Shell.png",
    portal_url: "https://atci.lkm.accenture.com/ShellUniversity/home",
    portal_content:
      "Upskill Shell Account employees at ATCI on key technologies.",
    portal_content_points: [
      `<ul>
        <li>Role-based learning: API Automation Testing, Manual Testing, SRE, TOSCA</li>
        <li>Skill-based learning: Azure, Power BI, Python, SAP – ABAB, Fieldglass, MM, JVA, Finance, and Selenium</li>
        <li>Process-based learning: General Process, SAP MM</li>
      </ul>`,
    ],
  },
  {
    id: 13,
    title: "Sodexo Talent Academy",
    img_url: "images/Academies/clientspecific/SodexoUniversity-New-Brand.png",
    portal_url: "https://atci.lkm.accenture.com/SodexoUniversity/home",
    portal_content:
      "Upskill Sodexo Account employees at ATCI on cutting-edge technologies.",
    portal_content_points: [
      `<ul>
        <li>Role-based learning: API Automation Testing, Manual Testing, SRE, TOSCA Skill-based learning: Sap MM, Power BI, Python Process-based learning: General Process, SAP MM</li>
      </ul>`,
    ],
  },
  {
    id: 14,
    title: "TC Energy Talent Academy",
    img_url: "images/Academies/clientspecific/TCAcademy-New-Brand-Latest.png",
    portal_url: "https://atc.lkm.accenture.com/TCEnergyTalentAcademy/",
    portal_content:
      "Shape a versatile, future-proof workforce with diverse expertise for TC Energy University",
    portal_content_points: [
      `<ul>
        <li>Mandatory Learning: TC energy Learning Prep Infographic, TC Prep School Video</li>
        <li>Role Based Learning:  Infrastructure Service, Service Desk Support, Application</li>
      </ul>`,
    ],
  },
  {
    id: 15,
    title: "Vertex Academy",
    img_url: "images/Academies/clientspecific/Vertex-New-Brand-Latest.png",
    portal_url: "https://atc.lkm.accenture.com/VertexTalentAcademy/home",
    portal_content:
      "Upskill Vertex Account employees at ATCI on cutting-edge technologies.",
    portal_content_points: [
      `<ul>
        <li>Role-based learning: Salesforce Development, Data Engineering and Talend</li>
        <li>Skill-based learning:  Power BI</li>
        <li>Product-based learning</li>
      </ul>`,
    ],
  },
  {
    id: 16,
    title: "Vodafone Academy",
    img_url: "images/Academies/clientspecific/Vodafone-new-Brand.png",
    portal_url:
      "https://atci.lkm.vodafoneacademy.accenture.com/VodafoneTalentAcademy",
    portal_content:
      "Create a future-skilled workforce with multiple skills for Vodafone Account employees at ATCI.",
    portal_content_points: [
      `<ul>
        <li>Roles: Automation Engineer, Backend Developer, Full Stack Engineering, System Engineer, Web Developer</li>
      </ul>`,
    ],
  },
  {
    id: 17,
    title: "Ignite",
    img_url: "images/Academies/clientspecific/Ignite.png",
    portal_url:
      "https://ignite.accenture.com/",
    portal_content:
      "Ignite is a strategic learning initiative for Accenture Song employees, designed to build future-ready capabilities and enable industry-led digital customer technology transformation.",
    portal_content_points: [
      // `<ul>
      //   <li>Ignite is a strategic learning initiative for Accenture Song employees, designed to build future-ready capabilities and enable industry-led digital customer technology transformation.</li>
      // </ul>`,
    ],
  }
];
